var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Square",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.9 141.9",
    style: {
      enableBackground: "new 0 0 141.9 141.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#F3A623;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#F3A623;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Github Inverted Yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    className: "st0",
    width: 137.9,
    height: 137.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,125.5l-0.2-19.4c0,0-13.3,6.8-20.6-3.5c-1.7-2.4-2.5-6.5-5.9-10.4c-2.1-2.5-4.3-3.3-4.7-5.2 c-0.2-1.1,0.1-1.5,1-2.1c2-1.4,6.4,1.8,8,3c7,5.1,6.2,9.7,10.4,11.1c5.6,1.9,11.6-2.8,11.6-2.8c-0.2-3.3,1.3-6.4,3.9-8.3 c-6.2,0.1-12.3-1.6-17.6-4.8c-4.9-3.1-8.9-7.7-11.3-13c-6.2-20.7,4.5-32,4.5-32c-0.6-2.1-0.9-4.2-1-6.3c-0.2-5,1.2-9.9,2.9-11.5 c3,0.3,6,1,8.8,2.3c5.3,2.4,8.8,4.4,8.8,4.4s11.7-1.8,17.1-1.6c5.5,0.2,11,0.6,16.4,1.4c2.1-1.3,4.3-2.4,6.5-3.5 c3.6-1.9,7.6-2.8,11.6-2.5c1.8,5.5,2.1,11.3,0.7,16.9c8.9,12.5,8.8,28.5,0.5,39.1C100.9,87.7,87.2,88,85.3,88 c3,2.2,3.8,6.9,3.9,8.6c0.4,6.3,0.9,29,0.9,29L57.9,125.5L57.9,125.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubActive);
export default __webpack_public_path__ + "static/media/github-active.7912aa66ff3b54a7e6a1e840192e6f30.svg";
export { ForwardRef as ReactComponent };